import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { ExternalLink } from 'lucide-react';

const PortfolioSection = () => {
  const { t } = useTranslation();
  const portfolioItems = [
    {
      id: 8,
      title: "Landing Page for Redoc.nu",
      subtitle: "Redoc.nu",
      url: "https://redoc.nu/",
      image: "/portfolio/redoc-nu.png"
    },
    {
      id: 7,
      title: "Fullstack App for Financial Reconciliation",
      subtitle: "Recon.ai",
      url: "https://recon.redoc.se/",
      image: "/portfolio/recon-ai.png"
    },
    {
      id: 6,
      title: "Fullstack App for Quality Management System",
      subtitle: "Redoc QMS",
      url: "https://reko-audit-portal.emergent.host/login",
      image: "/portfolio/reko-audit-portal.png"
    },
    {
      id: 5,
      title: "Landing Page for Logardt Ekonomiresurs",
      subtitle: "Logardt Ekonomiresurs",
      url: "https://logardtekonomiresurs.se/",
      image: "/portfolio/ekonomiresurs-nu.png"
    },
    {
      id: 4,
      title: "Landing Page for Redoc AML & KYC",
      subtitle: "amlkyc.nu",
      url: "https://amlkyc.nu/",
      image: "/portfolio/redoc-aml-kyc.png"
    },
    {
      id: 3,
      title: "Landing Page for Orchestra Administration Platform",
      subtitle: "orkesteradmin.se",
      url: "https://orkesteradmin.se",
      image: "/portfolio/orkesteradmin-se.png"
    },
    {
      id: 2,
      title: "Fullstack App for Vacation Property Rental Platform",
      subtitle: "holidayhomes.top",
      url: "https://holidayhomes.top",
      image: "/portfolio/holidayhomes-top.png"
    },
    {
      id: 1,
      title: "Landing Page for Author website",
      subtitle: "logart.shop",
      url: "https://logart.shop",
      image: "/portfolio/logart-shop.png"
    }
  ];

  return (
    <section 
      id="portfolio"
      className="font-display" style={{
        background: '#FAFAFA',
        padding: '100px 7.6923%',
        position: 'relative'
      }}
    >
      <div 
        className="font-display" style={{
          maxWidth: '1400px',
          margin: '0 auto'
        }}
      >
        {/* Section Header */}
        <div 
          className="font-display" style={{
            textAlign: 'center',
            marginBottom: '60px'
          }}
        >
          <p 
            className="font-display" style={{
              color: '#E5A93D',
              fontSize: '12px',
              fontWeight: '600',
              letterSpacing: '2px',
              marginBottom: '16px',
              textTransform: 'uppercase'
            }}
          >
            {t('portfolio.tagline')}
          </p>
          <h2 
            className="font-display" style={{
              fontSize: '48px',
              fontWeight: '700',
              color: '#0D2C22',
              marginBottom: '16px'
            }}
          >
            {t('portfolio.title')}
          </h2>
          <p
            className="font-display" style={{
              color: 'rgba(13, 44, 34, 0.7)',
              fontSize: '18px',
              maxWidth: '700px',
              margin: '0 auto'
            }}
          >
            {t('portfolio.description')}
          </p>
        </div>

        {/* Carousel */}
        <div style={{ position: 'relative', paddingLeft: '60px', paddingRight: '60px' }}>
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {portfolioItems.map((item) => (
                <CarouselItem key={item.id} className="md:basis-1/2 lg:basis-1/2">
                  <div style={{ padding: '10px' }}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-display" style={{
                        display: 'block',
                        position: 'relative',
                        background: '#121212',
                        border: '1px solid rgba(13, 44, 34, 0.1)',
                        borderRadius: '0px',
                        overflow: 'hidden',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        textDecoration: 'none'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.border = '1px solid #0D2C22';
                        e.currentTarget.style.transform = 'translateY(-5px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.border = '1px solid #1a1a1a';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      {/* Image Container */}
                      <div 
                        className="font-display" style={{
                          position: 'relative',
                          width: '100%',
                          height: '400px',
                          overflow: 'hidden',
                          background: '#F7F5F0'
                        }}
                      >
                        <img
                          src={item.image}
                          alt={item.title}
                          className="font-display" style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'top',
                            transition: 'transform 0.3s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        />
                        
                        {/* Overlay on Hover */}
                        <div
                          className="font-display" style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(13, 44, 34, 0.05)',
                            opacity: 0,
                            transition: 'opacity 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.opacity = '1';
                          }}
                        >
                          <div
                            className="font-display" style={{
                              background: '#E5A93D',
                              color: '#FFFFFF',
                              padding: '12px 24px',
                              borderRadius: '0px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              fontWeight: '600'
                            }}
                          >
                            <span>{t('portfolio.viewLive')}</span>
                            <ExternalLink size={18} />
                          </div>
                        </div>
                      </div>

                      {/* Text Content */}
                      <div style={{ padding: '24px' }}>
                        <h3
                          className="font-display" style={{
                            color: '#FFFFFF',
                            fontSize: '20px',
                            fontWeight: '600',
                            marginBottom: '8px',
                            lineHeight: '1.4'
                          }}
                        >
                          {item.title}
                        </h3>
                        <div
                          className="font-display" style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: '#E5A93D',
                            fontSize: '16px'
                          }}
                        >
                          <span>{item.subtitle}</span>
                          <ExternalLink size={16} />
                        </div>
                      </div>
                    </a>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            
            {/* Custom Styled Navigation Buttons */}
            <CarouselPrevious 
              className="font-display" style={{
                background: '#E5A93D',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '0px',
                width: '40px',
                height: '40px'
              }}
            />
            <CarouselNext 
              className="font-display" style={{
                background: '#E5A93D',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '0px',
                width: '40px',
                height: '40px'
              }}
            />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;